import type { SelectHTMLAttributes } from 'react';

interface Option {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: Option[];
  error?: string;
}

export function Select({ label, options, error, className = '', ...props }: SelectProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#1f2933] dark:text-[#e5e5e5] mb-1.5 font-mono">
          {label}
        </label>
      )}
      <select
        className={`
          w-full px-3 py-2 bg-white dark:bg-[#1a1a1a] dark:text-[#e5e5e5] border rounded-none
          focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500
          font-mono text-sm
          ${error ? 'border-red-500' : 'border-gray-300 dark:border-[#333333]'}
          ${className}
        `}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-xs text-red-600 font-mono">{error}</p>}
    </div>
  );
}
